<template>
  <layout-vertical v-if="loading">
    <router-view :key="$route.path" />
  </layout-vertical>
</template>

<script>
import LayoutVertical from "@core/layouts/layout-vertical/LayoutVertical.vue";
import AppCustomizer from "@core/layouts/components/app-customizer/AppCustomizer.vue";
import { $themeConfig } from "@themeConfig";

export default {
  components: {
    AppCustomizer,
    LayoutVertical,
  },
  data() {
    return {
      showCustomizer: $themeConfig.layout.customizer,
    };
  },
  computed: {
    loading() {
      return this.$store.getters["appConfig/updateConfig"];
      // return true;
    },
  },
};
</script>
